import { Check, Phone, View } from "lucide-react";
import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'


type AppCustomPropertyPhoneProps = {
    customProperty: CustomProperty;
    data: any;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyPhone = ({customProperty, data, validate, onChange} : AppCustomPropertyPhoneProps) => {

    const [phone, setPhone] = useState<string>(data as string || "");

    useEffect(() => {
        onChange(customProperty.label, phone);
    }, [phone]);

    return (
        <div className="app-custom-property-phone">
            {/* <div className="app-custom-property-label">
                {customProperty.label}
            </div> */}
            <div className="app-custom-property-value">
               
                <PhoneInput
                    country={"us"}
                    value={phone}
                    enableSearch={true}
                    onChange={phone => setPhone(phone)}
                    // disabled={true}
                    inputStyle={{
                        // backgroundColor: "var(--ftAnswerBackgroundColor)",
                        backgroundColor: "transparent",
                        width: "250px",
                        color: "var(--ftAnswerColor)",
                        border: "1px solid var(--ftAnswerColor)",
                        fontSize: "1rem"
                    }}
                    dropdownStyle={{
                        backgroundColor: "transparent",
                        border: "1px solid var(--ftAnswerColor)"
                    }}
                    buttonStyle={{
                        backgroundColor: "transparent",
                        border: "1px solid var(--ftAnswerColor)"
                    }}
                    inputClass="app-custom-property-phone-input"
                />
                {validate && !phone && customProperty.required &&
                    <div className="app-employee-record-error">
                        <Check size={16} color="red"/>
                    </div>
                }
            </div>
        </div>
    )
}
